import { render } from "./footerUl.vue?vue&type=template&id=482557b0&scoped=true"
import script from "./footerUl.vue?vue&type=script&lang=js"
export * from "./footerUl.vue?vue&type=script&lang=js"

import "./footerUl.vue?vue&type=style&index=0&id=482557b0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-482557b0"

export default script